import React, { Component } from 'react';
import Constants from './../constants/Constants';

class Card extends Component {

    constructor(props) {
        super(props);
        this.state = {
            overStyle: {},
            left: props.left,
            top: props.top,
            rotateDegCard: this.props.rotateDegCard,
            sideShown: false,
            layer: 1,
            clicked: false,
            scale: false,
            cardWidth: this.props.cardWidth,
            transitionInterval: Constants.INTERVAL_CARD_MOVE_FULL / 1000,
        };

        this.id = this.props.index;
        this.type = this.props.type;
        this.x = false;
        this.currentDeg = 0;
        this.yDomain = 120;
        this.xDomain = 60;
        this.isRotate = false;
        this.axis = Card.VERTICAL;
        this.index = props.index;
        this.back = props.back;
        this.front = props.front;
        this.randomize = true;
        this.scalePerc = null;
        this.gameCtx = props.gameCtx;
        this.owner = props.owner;
        this.parentObj = this.props.parentObj;
        this.onCardClickObj = { singleTime: false };
        this.onCardClick = null;

        this.cardName = "";
        this.cardSound = "";
        this.playSoundOn = null;
    }

    cardScaleValue = () => {
        return this.scalePerc;
    }

    getCurrentDeg = () => {
        return this.currentDeg;
    }

    changePos = (left, top, rotDeg, sideShown = true, scale = true, transitionInterval = Constants.INTERVAL_CARD_MOVE_FULL / 1000, layer = 1) => {
        let clicked = this.state.clicked
        let cardWidth = this.state.cardWidth

        this.setState({ left, top, rotDeg, sideShown, clicked, scale, cardWidth, transitionInterval, layer });
    }

    getPos = () => {
        return [this.state.left, this.state.top, this.state.rotDeg];
    }

    setOnClick = (fn, singleTimeUse) => { //when someone clicks the button he sendes a function and defines it as onCardclick

        this.onCardClick = fn;
        this.onCardClickObj = { singleTime: singleTimeUse };
    }

    settingPositionWhileGamePaused = (styleObject) => {
        this.setState({ overStyle: styleObject })
    }

    getOnClick = () => {
        return this.onCardClick;
    }

    cardIsClicked = () => {
        if (typeof this.onCardClick == 'function') {
            this.onCardClick(this.parentObj);

            if (this.onCardClickObj && this.onCardClickObj.singleTime === true) {
                this.onCardClick = null;
                this.onCardClickObj = { singleTime: false };
            }
        }
    }

    unsubscribeOnClick = () => {
        this.setState({ changeLayer: false });
        this.onCardclick = null;
    }

    componentDidMount = () => {

    }

    flipCards = () => {
        this.setState({ clicked: true });
    }

    onAfterCardThrownFromPlayerToUsedPile = async () => {
        if (this.playSoundOn === Constants.CARD_EVENT_ON_AFTER_CARD_THROWN_FROM_PLAYER_TO_USED_PILE) {
            this.gameCtx.soundRepository.playSoundByName(this.cardSound);
        }
    }

    onAfterPlayerGetCardFromNewPileOrUsedPile = (card, entityIndex) => {
        if (entityIndex === Constants.MY_PLAYER_INDEX && this.playSoundOn === Constants.CARD_EVENT_ON_AFTER_PLAYER_GET_CARD_FROM_NEW_PILE_OR_USED_PILE) {
            this.gameCtx.soundRepository.playSoundByName(this.cardSound);
        }
    }

    getOwner = () => {
        return this.gameCtx.entitiesRepo.getEntityByIndex(this.parentObj.owner);
    }

    render() {
        const rotateDeg = this.state.rotDeg;
        const cardWidth = this.state.cardWidth;
        this.scalePerc = this.state.scale ? 1.2 : 1;

        const cardStyle = {
            zIndex: this.state.scale ? this.state.layer + 1 : this.state.layer,
            width: cardWidth,
            position: 'absolute', left: this.state.left, top: this.state.top,
            WebkitTransform: 'rotate(' + rotateDeg + 'deg) scale(' + this.scalePerc + ')',
            MozTransform: 'rotate(' + rotateDeg + 'deg) scale(' + this.scalePerc + ')',
            OTransform: 'rotate(' + rotateDeg + 'deg) scale(' + this.scalePerc + ')',
            msTransform: 'rotate(' + rotateDeg + 'deg) scale(' + this.scalePerc + ')',
            transition: 'all ' + this.state.transitionInterval + 's ease-in-out',
            ...this.state.overStyle
        };

        const cardValue = this.state.sideShown ? this.front : this.back;

        return (
            <div className="card"
                id={this.id}
                style={cardStyle}
                onClick={() => { this.cardIsClicked() }}  >
                <img
                    className='card-style'
                    alt="card_img"
                    draggable="false"
                    src={require('./../../media/images/cards/' + cardValue + '.png')} />
            </div>
        );
    }
}

export default Card;

